import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ReactCollapsible from 'react-collapsible';
export const Collapsible = (props) => {
    const { children, contentContainerTagName, contentOuterClassName, isOpen, transitionTime = 250, } = props;
    return (_jsx(ReactCollapsible, Object.assign({ contentContainerTagName: contentContainerTagName, contentOuterClassName: contentOuterClassName, open: isOpen, transitionTime: transitionTime, trigger: '' }, { children: children })));
};
